<template>
    <div class="card">
        <div class="card">
            <TabMenu :model="items"/>
            <router-view/>
        </div>
    </div>
</template>

<script>

export default {
    name: "PresenceRouter",
    components: {},
    data() {
        return {
            items: [
                {
                    label: 'נוכחות',
                    icon: 'pi pi-clock',
                    to: '/presence',
                    admin: false
                },
                {
                    label: 'נוכחות קבועה',
                    icon: 'pi pi-check-square',
                    to: '/presence/constant',
                    admin: false
                },
            ]
        }
    },
}
</script>

<style scoped>
>>> .p-menuitem-link span {
    margin-left: 7px
}
</style>